import BaseImage from "./base-image"

export default class ManipulativeImageParent extends BaseImage {
  /**
   * @param id {string}
   * @param metadata {ElementMetadata}
   * @param center {Point} The center of the image
   * @param imageSize {Size} the size of the image on the canvas before scaling and rotation
   * @param scale {number} the relative scale of the image
   * @param rotation {number}
   * @param url {string}
   */
  constructor(id, metadata, center, imageSize, scale, rotation, url) {
    super(
      id,
      ManipulativeImageParent.type,
      metadata,
      center,
      imageSize,
      scale,
      rotation,
      url,
    )
  }

  /**
   * @return {string}
   */
  static get type() {
    return "mimage_parent"
  }

  get typeDisplay() {
    return "manipulative image"
  }

  /**
   * @return {boolean}
   */
  get isParentManipulative() {
    return true
  }

  /**
   * Merges properties from another instance of the same class into this object
   * @param other {ManipulativeImageParent}
   */
  merge(other) {
    this._metadata = other._metadata || this._metadata
    this._location = other._location || this._location
    this._imageSize = other._imageSize || this._imageSize
    this._scale = other._scale || this._scale
    this._rotation =
      other._rotation === 0 ? 0 : other._rotation || this._rotation

    const oldUrl = this._url
    this._url = other._url || this._url

    if (this._url !== oldUrl) {
      if (this._image) {
        this._image.attr({ href: this.url })
      }
      this._preload()
    }

    this._size = this._imageSize.times(this._scale)
    this.tryUpdate()
  }

  /**
   * Extracts the persisted values from this entity into something compatible with the merge function
   * @returns {object}
   */
  snapshot() {
    return {
      _metadata: this._metadata,
      _location: this._location,
      _imageSize: this._imageSize,
      _scale: this._scale,
      _rotation: this._rotation,
      _url: this._url,
    }
  }

  /**
   * Creates a new element from a snapshot
   * @param id {string}
   * @param snapshot {object}
   * @returns {ManipulativeImageParent}
   */
  fromSnapshot(id, snapshot) {
    return new ManipulativeImageParent(
      id,
      snapshot._metadata,
      snapshot._location,
      snapshot._imageSize,
      snapshot._scale,
      snapshot._rotation,
      snapshot._url,
    )
  }
}
